/** @format */

import { Grid } from '@mui/material';
import { Button } from 'src/components';
import { Avatar } from 'src/components/header/avatar';

const ProfilePictureSection = ({
  t,
  i18n,
  userLoading,
  userProfile,
  userProfilePicture,
  userData,
  inputFileRef,
  onDeleteProfilePicture,
  onChangeProfilePicture,
  avatarError
}) => {
  return (
    <Grid container className="personal-data__card">
      <h4 className="sub_head">{t('personalData.profilepic')}</h4>
      <Grid container className="personal-data__profile-img">
        <Grid className="profile_pic">
          <Avatar
            loading={userLoading || userProfile.pictureLoading}
            srcImg={userProfilePicture}
            name={`${userData?.firstName} ${userData?.lastName}`}
          />
        </Grid>
        <Grid className="profile_pic_right">
          <Grid className="profile-picture-name">profile.png</Grid>
          <Grid container className="personal-data__profile-img-btns">
            <Grid item xs={6} className="personal-data__profile-action">
              <Button
                disabled={userLoading || !userProfilePicture}
                label={t('common.button.delete')}
                className={`secondary delete-button--${i18n.language}`}
                onClick={onDeleteProfilePicture}
              />
            </Grid>
            <Grid item xs={6} className="personal-data__profile-action button text">
              <input
                ref={inputFileRef}
                type="file"
                accept=".jpg, .jpeg, .png"
                disabled={userLoading}
                onChange={onChangeProfilePicture}
                id="profilePictureUploadBtn"
                className="personal-data__hidden-input"
              />
              <label
                htmlFor="profilePictureUploadBtn"
                className={`orange-button upload-btn upload-btn--${i18n.language}`}>
                {t('personalData.uploadBtn')}
              </label>
            </Grid>
          </Grid>
          {avatarError ? <Grid className="page_error">{avatarError}</Grid> : null}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProfilePictureSection;
